import * as PIXI from 'pixi.js';
import { Game } from '../game';
import { Anchor } from 'springroll';
import { LoadContext } from '../utils';

export abstract class Scene extends PIXI.Container
{
    protected game: Game;
    protected anchors: Anchor[];
    protected loader: LoadContext = null;

    constructor(game: Game)
    {
        super();
        this.game = game;
        this.anchors = [];
    }

    async preload()
    {
        this.loader = new LoadContext(true);
    }
    /**
     * start() is called when the loader is no longer visible and the scene should activate
     */
    abstract start(): void;
    abstract update(deltaTime: number): void;
    cleanup(): void
    {
        for (const anchor of this.anchors)
        {
            this.game.scaleManager.removeEntity(anchor);
        }
        this.loader.destroy();
    }

    protected addAnchoredChild(child:PIXI.DisplayObject, anchor:Anchor)
    {
        this.addChild(child);
        this.anchors.push(anchor);
        this.game.scaleManager.addEntity(anchor);
    }

    /**
     * Shorthand for seeing if audio descriptions should play
     */
    public get shouldPlayAD(): boolean
    {
        return this.game.settings.playAudioDescriptions.value;
    }
}